import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector/cjs"
import { initReactI18next } from "react-i18next"
import translationFR from "./fr/translation.json"

const resources = {
  fr: {
    translation: translationFR,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "fr",
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
